<template>
    <div>
        <div v-on:click="edit">
            <div v-show="!editMode">
                <span
                v-if="!isTextArea"
                >
                    {{text}}
                </span>
                <p v-else>
                    {{text}}
                </p>
            </div>
        </div>
        <div v-show="editMode">
            <v-text-field
                ref="input"
                dense
                :clearable=editMode
                :autofocus=true
                v-bind:value="text" 
                v-on:change="updateValue"
                hide-details=""
                v-if="!isTextArea"
            >
                {{text}}
            </v-text-field>

            <v-textarea
                ref="input"
                dense
                :clearable=editMode
                :autofocus=true
                v-bind:value="text" 
                v-on:change="updateValue"
                hide-details=""
                :rows="11"
                v-else
            >
            {{text}}
            </v-textarea>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'TextEditor',
        props: {
            //Value to use for the text model
            value: {
                default : "",
                type : String
            },
            //Should a edit icon be shown
            showIcon: {
                default: true,
                type: Boolean
            },
            //Force component to be in edit mode
            forcedEdit: {
                default: false,
                type: Boolean
            },
            //Allow interaction with editor
            allowClick: {
                default: false,
                type: Boolean
            },
            //Is a text area rather than a text field, this is required for certain types of formatting (like returns)
            isTextArea: {
                default : false,
                type: Boolean
            }
        },
        data: function () {
            return {
                editMode: false,
                text : ""
            };
        },
        methods: {
            edit: function () {
                
                if(this.allowClick)
                {
                    this.editMode = true;  
                }
            },
            updateValue: function (value) {

                if(!this.forcedEdit)
                {
                    this.editMode = false;
                }

                this.$emit("onEdit",value);
            }
        },
        watch: {
            value : {
                immediate : true,
                handler(newVal)
                {
                    this.text = newVal;
                }
            },
            editMode: function () {
                if (this.editMode) {
                    this.$nextTick(function () {
                        this.$refs.input.focus();
                    });
                }
            },
            forcedEdit: {
                immediate: true,
                handler(newVal) {
                    this.editMode = newVal;
                },
            },
        }
    }
</script>